<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 lg7 xl5>
      <v-card class="elevation-5 pa-5 mb-5">
        <v-layout justify-center>
          <v-card-title class="display-1 font-weight-regular primary--text">
            {{ appSettings && appSettings.brandName }} {{ $t("portal.name") }}
          </v-card-title>
        </v-layout>

        <v-layout justify-center>
          <v-flex xs10 sm8 md8 lg8>
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent="login"
              lazy-validation
              autocomplete="none"
            >
              <v-card-text>
                <v-alert
                  v-if="appSettings && appSettings.loginInfo"
                  dense
                  outlined
                  type="info"
                  color="primary"
                  class="py-5"
                >
                  <span
                    style="white-space: pre-line; display: inline-block; margin-top: -20px"
                  >
                    {{ appSettings.loginInfo | translate }}</span
                  >
                </v-alert>
                <v-text-field
                  v-model="username"
                  :label="$t('auth.username')"
                  :rules="[rules.required, rules.number]"
                  data-test="login-user"
                />
                <v-text-field
                  v-model="password"
                  :label="$t('auth.password')"
                  :rules="[rules.required]"
                  type="password"
                  autocomplete="none"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  data-test="login-pass"
                />
                <v-alert :value="incorrect" type="error" dense text>{{
                  $t("auth.incorrect")
                }}</v-alert>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  type="submit"
                  @click="login"
                  block
                  large
                  :disabled="!valid || loading"
                  :loading="loading"
                  class="primary white--text"
                  data-test="login-submit"
                  >{{ $t("auth.login") }}</v-btn
                >
              </v-card-actions>
            </v-form>

            <v-card-text>
              <p class="primary--text text-center">
                {{ $t("auth.forgotPassword") }}
              </p>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      username: "",
      password: "",
      rules: {
        required: (value) => !!value || this.$i18n.t("validation.required"),
        number: (value) =>
          /^\d+$/.test(value) || this.$i18n.t("validation.required"),
      },
      valid: true,
      loading: false,
      incorrect: false,
    };
  },
  computed: {
    ...mapState(["appSettings"]),
  },
  methods: {
    login() {
      if (this.$refs.form.validate()) {
        this.incorrect = false;
        this.loading = true;
        this.$store
          .dispatch("login", {
            username: this.username,
            password: this.password,
          })
          .then(() => {
            this.$router.push(this.$route.query.from || "/");
          })
          .catch(() => {
            this.incorrect = true;
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
